import { FC } from "react";
import { Checkbox } from "@mui/material";
import { colorPrimary, colorSecondary, darkenColor, lightenColor } from "@/constants/colors";
import { Hint } from "@/HOC";
import { CustomButtonWithCheckboxRoot } from "./CustomButtonWithCheckbox.styles";
import { ICustomButtonWithCheckbox } from "./CustomButtonWithCheckbox.props";

const CustomButtonWithCheckbox: FC<ICustomButtonWithCheckbox> = ({ isActive, variant = "outlined", hint = "", hintPosition, ...props }) => {
	return (
		<Hint hint={hint} position={hintPosition} width={props.fullWidth ? "100%" : undefined}>
			<CustomButtonWithCheckboxRoot
				variant={variant}
				type="button"
				{...props}
				sx={{
					// переопределение mui-primary цвета
					".MuiButton-colorPrimary&:not(.Mui-disabled)": {
						// для outlined
						"&.MuiButton-outlined": {
							color: isActive ? colorSecondary : colorPrimary,
							borderColor: isActive ? colorSecondary : "#bdbdbd",

							"&:hover": {
								borderColor: "inherit",
								backgroundColor: lightenColor(isActive ? colorSecondary : "#bdbdbd", "90%"),
							},
						},

						// для contained
						"&.MuiButton-contained": {
							backgroundColor: colorSecondary,

							"&:hover": {
								backgroundColor: darkenColor(colorSecondary, "10%"),
							},
						},

						// для text
						"&.MuiButton-text": {
							color: colorSecondary,

							"&:hover": {
								backgroundColor: lightenColor(colorSecondary, "90%"),
							},
						},
					},

					...props.sx,
				}}
			>
				<Checkbox
					checked={isActive}
					sx={{
						p: 0,
						mr: "6px",
						"& .MuiSvgIcon-root": {
							color:
								variant === "outlined"
									? props.disabled || !isActive
										? colorPrimary
										: colorSecondary
									: variant === "contained"
									? props.disabled
										? colorPrimary
										: "#fff"
									: props.disabled
									? colorPrimary
									: colorSecondary,
							fontSize: 18,
						},
						opacity: props.disabled ? 0.7 : undefined,
					}}
				/>
				{props.children}
			</CustomButtonWithCheckboxRoot>
		</Hint>
	);
};

export default CustomButtonWithCheckbox;
